// Brand & content constants for Monsieur Toast

export const BRAND = {
  name: "Monsieur Toast",
  email: "info@monsieurtoast.com",
  phone: "+971 56 336 48 28",
  phoneHref: "tel:+971563364828",
  phoneCH: "+41 79 203 46 44",
  phoneCHHref: "tel:+41792034644",
  address: {
    fr: "Bientôt, partout dans le monde",
    en: "Coming soon, worldwide",
  },
  social: {
    instagram: {
      handle: "@monsieurtoastofficial",
      url: "https://www.instagram.com/monsieurtoastofficial",
    },
    tiktok: {
      handle: "@monsieur.toast",
      url: "https://www.tiktok.com/@monsieur.toast",
    },
    facebook: { handle: "@MonsieurToast", url: "https://facebook.com/MonsieurToast" },
  },
};

export const ASSETS = {
  logoGold:
    "https://customer-assets.emergentagent.com/job_58f11671-d4cd-402d-b933-801d9f9e3bb9/artifacts/e9moo57v_Logo.png",
  logoBlack:
    "https://customer-assets.emergentagent.com/job_58f11671-d4cd-402d-b933-801d9f9e3bb9/artifacts/sd2ogw3y_Logo%20black.png",
  kiosk1:
    "https://customer-assets.emergentagent.com/job_58f11671-d4cd-402d-b933-801d9f9e3bb9/artifacts/lyvrt5h6_Monsieur%20Toast.png",
  kioskSide:
    "https://customer-assets.emergentagent.com/job_58f11671-d4cd-402d-b933-801d9f9e3bb9/artifacts/l5urue7k_Monsieur%20Toast%201.png",
  kioskFront:
    "https://customer-assets.emergentagent.com/job_58f11671-d4cd-402d-b933-801d9f9e3bb9/artifacts/307hq1ym_Monsieur%20Toast%202.png",
};

export const MENU = [
  {
    id: "classic",
    name: "Le Classique",
    subtitle: { fr: "Croque-Monsieur", en: "Croque-Monsieur" },
    description: {
      fr: "Pain au levain, jambon de volaille fumé, Comté affiné, béchamel, gratiné au gruyère.",
      en: "Sourdough, smoked poultry ham, aged Comté, béchamel, gruyère crust.",
    },
    price: "45",
    priceEUR: "12",
    image: "/le-classique.jpg",
  },
  {
    id: "truffle",
    name: "La Truffe",
    subtitle: { fr: "Truffe & Comté", en: "Truffle & Comté" },
    description: {
      fr: "Brioche, crème de truffe noire, Comté, mozzarella di bufala, ciboulette.",
      en: "Brioche, black truffle cream, Comté, mozzarella di bufala, chives.",
    },
    price: "83",
    priceEUR: "21",
    image: "/le-truffe.jpg",
  },
  {
    id: "chicken-pesto",
    name: "Le Pesto",
    subtitle: { fr: "Poulet & Pesto", en: "Chicken & Basil Pesto" },
    description: {
      fr: "Poulet rôti, pesto maison au basilic, mozzarella, tomate confite.",
      en: "Roasted chicken, house basil pesto, mozzarella, sun-dried tomato.",
    },
    price: "63",
    priceEUR: "17",
    image: "/le-pesto.jpg",
  },
  {
    id: "beef-cheese",
    name: "Le Boeuf",
    subtitle: { fr: "Boeuf & Cheddar", en: "Beef & Cheese" },
    description: {
      fr: "Boeuf braisé lentement, cheddar fumé, oignons caramélisés, mayonnaise à la moutarde.",
      en: "Slow-braised beef, smoked cheddar, caramelised onion, dijon mayo.",
    },
    price: "72",
    priceEUR: "18",
    image: "/le-boeuf.jpg",
  },
  {
    id: "vegetarian",
    name: "Le Jardin",
    subtitle: { fr: "Végétarien", en: "Vegetarian" },
    description: {
      fr: "Courgette grillée, aubergine, fromage de chèvre, roquette, zeste de citron.",
      en: "Grilled courgette, aubergine, goat cheese, rocket, lemon zest.",
    },
    price: "57",
    priceEUR: "15",
    image: "/le-jardin.jpg",
  },
  {
    id: "sweet",
    name: "Le Sucré",
    subtitle: { fr: "Pain Perdu", en: "Sweet Toast" },
    description: {
      fr: "Brioche perdue, crème à la vanille de Madagascar, banane caramélisée, poudre d'or.",
      en: "Brioche perdue, Madagascar vanilla cream, caramelised banana, gold dust.",
    },
    price: "48",
    priceEUR: "12",
    image: "/le-sucre.jpg",
  },
  {
    id: "sweet-sweet",
    name: "Le Chocolaté",
    subtitle: { fr: "Indulgence Chocolat", en: "Chocolate Indulgence" },
    description: {
      fr: "Brioche toastée, ganache au chocolat noir Valrhona, praliné noisette, éclats de cacao, fleur de sel.",
      en: "Toasted brioche, dark Valrhona chocolate ganache, hazelnut praline, cocoa nibs, sea salt.",
    },
    price: "36",
    priceEUR: "9",
    image: "/le-chocolate.jpg",
  },
];

// Navigation IDs (labels come from i18n)
export const NAV_IDS = ["story", "menu", "vibe", "find"];

